module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/AmwayIcons.ttf?5v2gxx
// module id = wQFX
// module chunks = 0